var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabbar-container"},_vm._l((_vm.list),function(v){return _c('span',{key:v.key,staticClass:"tabbar-item",class:{ is_active: _vm.value === v.key },on:{"click":function($event){return _vm.onItem(v.key)}}},[_vm._v(_vm._s(v.label))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }